export default "__VITE_ASSET__DdjAPvXW__"